<div class="page">
  <div class="center-column">
    <!-- ================= STEP 1 : OWNERSHIP ================= -->
    <div class="card ownership-card" *ngIf="step === 'ownership'">
      <h1>Vessel</h1>
      <p class="subtitle">Do you currently have a vessel?</p>

      <div class="option" [class.selected]="ownsVessel === true" (click)="ownsVessel = true">
        Yes, I own a vessel
      </div>

      <div class="option" [class.selected]="ownsVessel === false" (click)="ownsVessel = false">
        No, I don’t own a vessel
      </div>

      <lib-button class="continue-btn" variant="contained" size="medium" type="primary"
        [isDisabled]="ownsVessel === null" label="Continue" (click)="continue()"></lib-button>
    </div>

    <!-- ================= STEP 2 : VESSEL DETAILS ================= -->
    <div class="card details-card" *ngIf="step === 'details'">
      <div class="card-scroll">
        <h1>Vessel</h1>
        <p class="subtitle">
          Add your boats details to enhance your experience
        </p>

        <!-- PHOTOS -->
        <div class="photos">
          <div class="photo" [class.has-photo]="vesselPhotosPreviews[i]"
            *ngFor="let photo of vesselPhotos; let i = index"
            (click)="vesselPhotosPreviews[i] ? null : fileInput.click()">
            <ng-container *ngIf="vesselPhotosPreviews[i]; else addIcon">
              <img [src]="vesselPhotosPreviews[i]" />
              <div class="remove-btn" (click)="$event.stopPropagation(); removePhoto(i)">
                <mat-icon>close</mat-icon>
              </div>
            </ng-container>
            <ng-template #addIcon>
              <span>+</span>
            </ng-template>
          </div>
          <input #fileInput type="file" hidden multiple accept="image/*" (change)="onPhotoSelected($event)" />
        </div>

        <!-- FORM -->
        <div class="form-group">
          <label>Boat name*</label>
          <input placeholder="Sea Wanderer" [(ngModel)]="vessel.name"
            [class.invalid]="formSubmitted && !vessel.name.trim()" />
        </div>

        <div class="form-group">
          <label>Home port</label>
          <input placeholder="San Diego, CA – Shelter Island Harbor" [(ngModel)]="vessel.homePort" />
        </div>

        <div class="form-group">
          <label>Boat make</label>
          <input placeholder="Beneteau" [(ngModel)]="vessel.make" />
        </div>
        <div class="form-group">
          <label>Boat Model</label>
          <input placeholder="Beneteau" [(ngModel)]="vessel.model"
            [class.invalid]="formSubmitted && !vessel.model.trim()" />
        </div>
        <div class="row">
          <div class="form-group">
            <label>Length Overall(LOA)</label>
            <input placeholder="40 ft" [(ngModel)]="vessel.length" />
          </div>
          <div class="form-group">
            <label>Draft</label>
            <input placeholder="6 ft" [(ngModel)]="vessel.draft" />
          </div>
        </div>

        <div class="form-group">
          <label>Hull color</label>
          <div class="pill-group">
            <div class="pill" [class.selected]="hullColor === 'Light'" (click)="hullColor = 'Light'">
              Light
            </div>
            <div class="pill" [class.selected]="hullColor === 'Dark'" (click)="hullColor = 'Dark'">
              Dark
            </div>
            <div class="pill" [class.selected]="hullColor === 'Other'" (click)="hullColor = 'Other'">
              Other
            </div>
          </div>
        </div>



        <div class="section-title">
          Additional details <span class="optional">Optional</span>
        </div>

        <div class="form-group">
          <label>MMSI</label>
          <input [(ngModel)]="vessel.mmsi" placeholder="338765902" />
        </div>

        <div class="form-group">
          <label>Commercial number</label>
          <input [(ngModel)]="vessel.commercialNumber" placeholder="CA-2025-784392" />
        </div>
        <div class="form-group">
          <label>Fuel capacity</label>
          <input [(ngModel)]="vessel.fuelCapacity" placeholder="180 gallons" />
        </div>

        <div class="form-group">
          <label>Number of engines</label>
          <div class="pill-group">
            <div class="pill" *ngFor="let n of [1, 2, 3, 4, 5]" [class.selected]="engineCount === n"
              (click)="setEngineCount(n)">
              {{ n }}
            </div>
          </div>
        </div>

        <!-- DYNAMIC ENGINES AREA -->
        <div *ngFor="let engine of engines; let i = index" class="engine-unit">
          <div class="section-title">Engine {{ i + 1 }} Details</div>

          <div class="form-group">
            <label>Engine {{ i + 1 }} Type</label>
            <input [(ngModel)]="engine.engine_type" placeholder="e.g. Twin Outboard" />
          </div>

          <div class="form-group">
            <label>Engine {{ i + 1 }} Horsepower</label>
            <input [(ngModel)]="engine.horse_power" placeholder="e.g. 250" />
          </div>

          <div class="form-group">
            <label>Engine {{ i + 1 }} Fuel type</label>
            <div class="pill-group">
              <div class="pill" [class.selected]="engine.fuel_type === 'Gasoline'"
                (click)="engine.fuel_type = 'Gasoline'">
                Gasoline
              </div>
              <div class="pill" [class.selected]="engine.fuel_type === 'Fuel'" (click)="engine.fuel_type = 'Fuel'">
                Diesel
              </div>
            </div>
          </div>
        </div>
      </div> <!-- End of card-scroll -->
    </div> <!-- End of details-card -->

    <!-- ================= FOOTER (STEP 2 ONLY) ================= -->
    <div class="footer" *ngIf="step === 'details'">
      <lib-button variant="contained" size="medium" type="secondary" label="Back" (click)="goBack()"
        [isDisabled]="isSubmitting"></lib-button>

      <lib-button variant="contained" size="medium" type="primary" label="Next" (click)="NextPage()"
        [isLoading]="isSubmitting" [isDisabled]="isSubmitting"></lib-button>
    </div>
  </div>
</div>

<!-- <div class="loader-overlay" *ngIf="showLoader">
  <app-sail-loader></app-sail-loader>
</div> -->